import { Injectable } from '@angular/core';
import { createAction } from '@ngrx/store';

Injectable({
    providedIn: 'root'
});
export class AppointmentsActions {

    static openAppointmentsSettings = createAction('[Appointments:Settings] Open Appointments Setting');

    static openAppointmentsSettingsCancel = createAction(
        '[Appointments:Settings] Open Appointments Setting Cancelled');
}
